export default function() {
    const targetElement = document.querySelector('#order');
    if (targetElement) {
        targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        });
    }
}
